import {EntityData, identifier} from "@fedeltapointofsale/data-client";

export class IntegratedInstanceData extends EntityData<IntegratedInstanceData> {
    @identifier instanceId: string;
}
